<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('FIELD.APPROVAL.DUP.TITLE') }}</i>
                    </dt>
                    <dd>
                        <!-- Grid -->
                        <div class="grid_wrap">
                            <table class="scroll_table sm_grid noLine">
                                <thead>
                                    <tr class="text_center">
                                        <th width="25%">{{ $t('FIELD.ADMIN.NAME') }}</th>
                                        <th width="15%">{{ $t('FIELD.GLOBAL.CORPORATION') }}</th>
                                        <th width="15%">{{ $t('FIELD.USER.TEAM') }}</th>
                                        <th width="15%">{{ $t('FIELD.APPROVAL.TITLE') }}</th>
                                        <th width="15%">{{ $t('FIELD.USER.OFFICE') }}</th>
                                        <th width="15%">{{ $t('FIELD.USER.MOBILE') }}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center scroll" style="height:300px">
                                    <tr
                                        class="cur_pointer"
                                        v-for="item in path"
                                        :key="item.epId + 'DuplicationApprovalPopup'"
                                        @click="rowClick(item.epId)"
                                    >
                                        <td width="25%" class="text_left ellipsis" :title="item.enFullName">
                                            {{ item.enFullName }}
                                        </td>
                                        <td width="15%" class="text_left ellipsis" :title="item.enCompanyName">
                                            {{ item.enCompanyName }}
                                        </td>
                                        <td width="15%" class="text_left ellipsis" :title="item.enDepartmentName">
                                            {{ item.enDepartmentName }}
                                        </td>
                                        <td width="15%" class="text_left ellipsis" :title="item.enTitleName">
                                            . <!--  {{ item.enTitleName }} -->
                                        </td>
                                        <td width="15%" class="text_left ellipsis" :title="item.officeTelNumber">
                                            {{ item.officeTelNumber }}
                                        </td>
                                        <td width="15%" class="text_left ellipsis" :title="item.mobile">
                                            {{ item.mobile }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- //grid -->
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import $ from 'jquery';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';

export default {
    name: 'DuplicationApprovalPopup',
    props: {
        rtnFunc: { type: Function },
        propsPath: { type: Array },
    },
    data() {
        return {
            path: [],
        };
    },
    mounted() {
        this.path = this.propsPath;
    },
    methods: {
        rowClick(v) {
            const idx = this.path.findIndex(function(item) {
                return item.epId === v;
            });

            this.rtnFunc(this.path[idx]);
            this.$emit('close');
        },
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/common/popup/DuplicationApprovalPopup.vue